import React from 'react';
import PropTypes from 'prop-types';
import Select from 'common/components/elements/inputs/select-v2';
import './style.scss'

function CommentPermissionModal({
   isMobile,
   permission,
   onChangePermission,
}) {
   const options = [
      {
         name: 'Public, guests, and expired members CANNOT read or write comments',
         value: 'public_guests_and_expired_members_cannot_read_or_write',
      },
      {
         name: 'Public CANNOT read comments, Guests and expired members CAN read comments',
         value: 'public_cannot_read_guests_and_expired_members_can_read',
      },
      {
         name: 'Public CANNOT read comments, Guests and expired members CAN read and write comments',
         value: 'public_cannot_read_guests_and_expired_members_can_read_and_write',
      },
      {
         name: 'Public CAN read comments, Guests and expired members CAN read and write comments',
         value: 'public_can_read_guests_and_expired_members_can_read_and_write',
      },
      {
         name: 'Public, guests, and expired members CAN read comments but CANNOT write comments',
         value: 'public_guests_and_expired_members_can_read_cannot_write',
      },
      {
         name: 'Turn off commenting',
         value: 'turn_off_commenting',
      },

   ]
   return (
      <div className='content-comment-permission-select flex w-full flex-col'>
         <Select
            label='Who can read and write comments?'
            onSelectChange={ (value) => onChangePermission(value) }
            screenType={ !isMobile ? 'desktop' : 'mobile' }
            activeValue={ options.find(i => i.value === permission) }
            keyDisplayName='name'
            keyValue='value'
            name='collection_id'
            isEmptyText='You haven’t created any collections'
            options={ options }
            placeholder='Select Permistion'
            modalClassName='content-comment-permission-modal'
            isCloseAction={ false }
         />
      </div>
   )
}


CommentPermissionModal.propTypes = {
   isMobile: PropTypes.bool,
   permission: PropTypes.string,
   onChangePermission: PropTypes.func,
}
CommentPermissionModal.defaultProps = {
   onChangePermission: () => {},
}
export default CommentPermissionModal
